export { default as isCnpj } from './is-cnpj';
export { default as isJSON } from './is-json';
export { default as isCpf } from './is-cpf';
export { default as isCep } from './is-cep';
export { default as isEmail } from './is-email';
export { default as isInteger } from './is-integer';
export { default as isPhone } from './is-phone';
export { default as isOnlyNumbers } from './is-only-numbers';
